import type { Method } from 'lib/axios';
import { APICallV2Post, APICallV4 } from 'reactApp/api/APICall';
import { apiMigrateFileV2ToV4 } from 'reactApp/appHelpers/featuresHelpers';

const method = 'file/add';

class AddFileAPIV2Call extends APICallV2Post {
    _method = method;
}

class AddFileAPIV4Call extends APICallV4 {
    _method = method;
    _type: Method = 'post';
}

export const addFileApiCall = (params: Record<string, any>, options: { headers?: Record<string, string> } = {}): Promise<unknown> => {
    const apiInstance = apiMigrateFileV2ToV4.add ? new AddFileAPIV4Call() : new AddFileAPIV2Call();

    if ('headers' in options) {
        apiInstance._headers = { ...apiInstance._headers, ...options.headers };
    }

    return apiMigrateFileV2ToV4.add
        ? apiInstance
              .makeRequest({ ...params, path: params.home })
              .then((response) => response?.data?.body)
              .catch((error) => {
                  throw [error.response, error.status, error, error.responseText];
              })
        : apiInstance
              .makeRequest(params)
              .then((response) => response.data.body)
              .catch((error) => {
                  throw [error.response.body, error.status, error, error.responseText];
              });
};
